import Layout from '@/layout/Index.vue'

export default [
  {
    path: '/materialsManage',
    meta: { title: '物料管理' },
    component: Layout,
    redirect: '/materialsManage/list',
    children: [
      {
        path: 'list',
        meta: { title: '物料管理', activeMenu: '/materialsManage' },
        component: () => import('@/views/materialsManage/MaterialsManage.vue')
      },
      {
        path: 'detail',
        meta: { title: '物料详情', activeMenu: '/materialsManage' },
        component: () => import('@/views/materialsManage/MaterialsManageDetail.vue')
      },
      {
        path: 'add',
        meta: { title: '新增物料', activeMenu: '/materialsManage' },
        component: () => import('@/views/materialsManage/MaterialsManageAdd.vue')
      },
      {
        path: 'edit',
        meta: { title: '编辑物料', activeMenu: '/materialsManage' },
        component: () => import('@/views/materialsManage/MaterialsManageAdd.vue')
      },
      {
        path: 'add',
        meta: { title: '新增物料', activeMenu: '/materialsManage' },
        component: () => import('@/views/materialsManage/MaterialsManageAdd.vue')
      }

    ]
  }

]
